import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactHlsPlayer from "react-hls-player";
import {
  Box,
  Button,
  Grid,
  Input,
  Slide,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Tooltip,
} from "@mui/material";
import { Add, Cancel, Delete, Edit, Save, Search } from "@mui/icons-material";
import { AppSingleton } from "../services/user_config";

const NewsSection = () => {
  const playerRef = useRef();
  const theme = new AppSingleton().theme;
  const [tvOptions, setTvOptions] = useState([
    {
      name: "港台電視31",
      link: "https://rthktv31-live.akamaized.net/hls/live/2036818/RTHKTV31/master.m3u8",
    },
    {
      name: "港台電視32",
      link: "https://rthktv32-live.akamaized.net/hls/live/2036819/RTHKTV32/master.m3u8",
    },
    {
      name: "Now331",
      link: "https://ewcdn04.nowe.com/session/10-7355d11871b9dffd489f3b68acfe7/Content/DASH_VOS3/Live/channel(VOS_CH331)/manifest.mpd ",
    },
    // {
    //   name: "HOY 76",
    //   link: "https://hoytv-live-stream.hoy.tv/ch76/index-fhd.m3u8",
    // },
    // {
    //   name: "HOY 77",
    //   link: "https://hoytv-live-stream.hoy.tv/ch77/index-fhd.m3u8",
    // },
    // {
    //   name: "HOY 78",
    //   link: "https://hoytv-live-stream.hoy.tv/ch78/index-fhd.m3u8",
    // },
    // {
    //   name: "Fox",
    //   link: "https://www.facebook.com/video/playback/playlist.m3u8?v=1424172294994477&a=0",
    // },
  ]);
  const [selectedTvName, setSelectedTvName] = useState(tvOptions[0].name);
  const [selectedTvLink, setSelectedTvLink] = useState(tvOptions[0].link);

  useEffect(() => {
    const _options = tvOptions.filter((el) => el.name === selectedTvName);
    if (_options.length > 0) {
      setSelectedTvLink(_options[0].link);
    }
  }, [selectedTvName]);

  useEffect(() => {
    const fireOnVideoStart = () => {
      console.log("video on start");
      // Do some stuff when the video starts/resumes playing
    };
    playerRef.current.addEventListener("play", fireOnVideoStart);
    return playerRef.current.removeEventListener("play", fireOnVideoStart);
  }, []);

  return (
    <>
      <Slide
        direction="left"
        in={true}
        mountOnEnter
        unmountOnExit
        easing={{
          enter: theme.transitions.easing.easeOut,
          exit: theme.transitions.easing.easeIn,
        }}
        timeout={1000}
      >
        <Grid container spacing={2} sx={{ mt: 8 }}>
          <Grid key="controller" item xs={12} textAlign="center">
            <ToggleButtonGroup
              color="primary"
              value={selectedTvName}
              size="large"
              exclusive
              onChange={(evt, val) => {
                if (val !== null && val !== selectedTvName) {
                  setSelectedTvName(val);
                }
              }}
              aria-label="Platform"
            >
              {tvOptions.map((el) => (
                <ToggleButton key={el.name} value={el.name}>
                  {el.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
          <Grid key="player-window" item xs={12} loading="lazy">
            <ReactHlsPlayer
              playerRef={playerRef}
              src={selectedTvLink}
              autoPlay
              controls
              width="100%"
              height="auto"
              // config={{
              //   file: {
              //     forceHLS: true,
              //     hlsOptions: {
              //       withCredentials: true,
              //       xhrFields: {
              //         withCredentials: true,
              //       },
              //       enableWorker: false,
              //       xhrSetup: function (xhr, url) {
              //         console.log("xhr Setup");
              //         console.log(xhr);
              //         xhr.setRequestHeader("origin", `*`);
              //         xhr.setRequestHeader("referer", `*`);
              //       },
              //     },
              //   },
              // }}
            />
          </Grid>
        </Grid>
      </Slide>
    </>
  );
};

const f = () => {};

export { NewsSection, f };
